module.exports = __webpack_public_path__ + "static/media/buy_image.0165eaf3.jpg";